import { Tooltip } from '@mui/material';
import { TinyVariant } from '@shared/constants/components/tinyUtils';
import { IconName } from '../images/IconMap';
import Icons from '../images/Icons';
import SrOnlyText from '../text/SrOnlyText';
import { BoldTinyText, TinyRow, TinyText } from './CommonTinyStyles';

interface ITinyLabelProps {
    title: string;
    value?: string | number;
    hideLabel?: boolean;
    tooltip?: string;
    icon?: IconName;
    iconSize?: number;
    variant?: TinyVariant;
}

export default function TinyLabel({
    title,
    value,
    hideLabel,
    tooltip,
    icon,
    iconSize,
    variant = 'diminished',
}: Readonly<ITinyLabelProps>) {
    const tag = (
        <TinyRow $variant={variant} title={hideLabel && !tooltip ? title : undefined}>
            {icon && <Icons name={icon} weight="bold" size={iconSize || 14} />}
            {hideLabel ? <SrOnlyText>{title}</SrOnlyText> : <TinyText>{title}</TinyText>}
            {value !== undefined && <BoldTinyText>{value}</BoldTinyText>}
        </TinyRow>
    );

    if (!tooltip) return tag;

    return (
        <Tooltip title={tooltip} arrow>
            {tag}
        </Tooltip>
    );
}
